import {Storage, ToStorage} from "./storage";
import {fork, put, select, takeEvery} from "redux-saga/effects";
import {InstanceAction} from "../state/instance";
import {AppState} from "../state";
import {StatusRequiredAction} from "../state/status";


export function* instance() {
    //rczpi
    yield fork (function *() {
       yield takeEvery<InstanceAction>("Instance", function (action){
            ToStorage("rczpi", action.payload);
       });
    });

    yield fork (Storage, "rczpi", function*(value: any) {
        if (value) {
            const instance:number = yield select((app:AppState)=>app.instance);
            if (instance !== value) {
                yield put<StatusRequiredAction>({
                    type: "RequiredStatus",
                    payload: "STOP"
                });
            }
        }
    });
}